
<!-- 
    File: cgp-sidenav-item.template.html
    Author: Joseph M Diaz
    Date: 5/10/2017
    Desc: Sidenav item component.
    Other Contributors:
-->

<div class="cgp-sidenav-item-container" [hidden]="item.hidden">
        <div class="cgp-sidenav-item parent"
            *ngIf="itemHasChildren(); else noChildrenBlock"
            [ngClass]="{'first': item.isFirstItem, 'last': item.isLastItem, 'disabled': item.disabled, 'expanded': item.expanded}"
            (click)="toggleExpanded($event)"
        >
            <div class="cgp-sidenav-item-header">
                <span *ngIf="itemHasIcon" class="cgp-sidenav-item-header-icon" [ngClass]="item.iconClass"></span>
                <span>{{item.title}}</span>
    
                <span class="cgp-sidenav-item-toggle">
                    <i class="fa fa-caret-up" [ngClass]="{'fa-caret-up': item.expanded, 'fa-caret-down': !item.expanded}"></i>
                </span>
            </div>
    
            <div *ngFor="let childItem of item.children" [hidden]="!item.expanded">
                <cgp-sidenav-item [item]="childItem"></cgp-sidenav-item>
            </div>
        </div>
    
        <ng-template #noChildrenBlock>
            <div class="cgp-sidenav-item"
                [ngClass]="{'first': item.isFirstItem, 'last': item.isLastItem, 'disabled': item.disabled, 'selected': item.selected}"
                (click)="onItemClick($event)">
                <span class="cgp-sidenav-item-header">
                    <span *ngIf="itemHasIcon" class="cgp-sidenav-item-header-icon" [ngClass]="item.iconClass"></span>
                    <span>{{item.title}}</span>
                </span>
            </div>
        </ng-template>
    </div>